import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"

class ProtectedRoute extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      token: PropTypes.string,
      user: PropTypes.object,
    }),
    render: PropTypes.func,
  }

  static defaultProps = { auth: null, render: null }

  componentDidMount() {
    this.mounted = true
    this.startCheckForInactivity()
  }

  componentWillUnmount() {
    this.mounted = false
    clearInterval(this.checkForInactivityIntervalHandler)
  }

  logoutIfNeed = () => {
    let allowedTimeFrmLastAction = 60 * 60 * 1000
    if (this.props?.auth?.user?.groups?.lab) { 
      allowedTimeFrmLastAction *= 2
    }
    const loginDate = window.localStorage.getItem("login_date")
    if (this.mounted && new Date().getTime() - localStorage.getItem("last_action") > allowedTimeFrmLastAction ||
    loginDate !== new Date().toDateString()) {
      localStorage.clear()
      window.location.reload()
    }
  }

  startCheckForInactivity() {
    this.logoutIfNeed()
    this.checkForInactivityIntervalHandler = setInterval(this.logoutIfNeed, 1000 * 60)
  }

  render() {
    if (!this.props.auth) {
      const login = `/login?continueWith=${window.location.pathname}`
      return <Redirect {...this.props} to={login} />
    }
    return <Route {...this.props} />
  }
}

export default connect(({ auth }) => ({ auth }))(ProtectedRoute)
